import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { gutters } from 'app/spacing';
import AddButton from 'components/Button/AddButton';
import { useEditor } from 'components/WYSIWYG';
import { MergeFieldModal } from 'components/WYSIWYG/components/MergeFieldModal';
import { insertMergeField } from 'components/WYSIWYG/utils/commands';

import { useMergeFields } from 'components/WYSIWYG/use-merge-fields';
import { useGridLikeFlexChildProps } from 'components/StandaloneToolBar/components/GridLikeFlex';
import { TextEditorToolbarSection } from 'components/StandaloneToolBar/styles';

import { useModalControl } from 'hooks/useModalControl';
import { MultiSourceMergeModal } from '../../components/MultiSourceMergeModal';

const InsertMergeFieldButton = styled(AddButton)`
  width: 154px;
  padding: 0;
  margin: 0 ${gutters.spacing(3)}px;
  height: unset;
  line-height: unset;
  cursor: pointer;
`;

const ToolbarSuggestionContainer = styled.div`
  position: relative;
`;

const ToolbarSuggestion = ({
  onChange,
  onCloseModal,
  mergeFields,
  wideMergePicker = false,
  enableAllObjectMergeFields = false,
}) => {
  const { t } = useTranslation();

  const [modalOpen, { showModal, hideModal }] = useModalControl();
  const handleModalClose = () => {
    hideModal();
    onCloseModal();
  };

  const handleSelect = (value) => {
    hideModal();
    onChange(value);
  };

  return (
    <ToolbarSuggestionContainer>
      {modalOpen && !enableAllObjectMergeFields && (
        <MultiSourceMergeModal
          show={modalOpen}
          onConfirm={handleSelect}
          onHide={handleModalClose}
          mergeFields={mergeFields}
          wideMergePicker={wideMergePicker}
        />
      )}
      {modalOpen && enableAllObjectMergeFields && (
        <MergeFieldModal
          show={modalOpen}
          onConfirm={handleSelect}
          onHide={handleModalClose}
        />
      )}
      <InsertMergeFieldButton
        as="span"
        color="blue"
        className="insert-btn"
        onClick={showModal}
      >
        {t('Insert Merge Field')}
      </InsertMergeFieldButton>
    </ToolbarSuggestionContainer>
  );
};

export const InsertMultiSourceMergeFieldToolbarSection = ({
  enableAllObjectMergeFields = false,
  mergeFields,
  appendMergeFieldExtraSpace,
  wideMergePicker,
}) => {
  const editor = useEditor();
  const [ref, props] = useGridLikeFlexChildProps();
  const { data, isLoading } = useMergeFields({
    enabled: !enableAllObjectMergeFields,
    listHeaders: true,
    mergeFields,
  });

  const handleModalClose = () => {
    editor.chain().focus().run();
  };

  if (!editor) return null;
  return (
    <TextEditorToolbarSection ref={ref} {...props}>
      <ToolbarSuggestion
        options={data}
        isLoading={isLoading}
        onCloseModal={handleModalClose}
        enableAllObjectMergeFields={enableAllObjectMergeFields}
        mergeFields={mergeFields}
        wideMergePicker={wideMergePicker}
        onChange={(mergeFieldData) => {
          editor
            .chain()
            .focus()
            .command(
              insertMergeField(mergeFieldData, appendMergeFieldExtraSpace)
            )
            .run();
        }}
      />
    </TextEditorToolbarSection>
  );
};
